import { Button } from "@mui/material"
import css from './DescargarDocumentos.module.css'

const DescargarDocumentos = ({ onDownloadCondiciones, onDownloadRGPD }) => (
  <div className={css.download}>
    <Button
      color="primary"
      variant='contained'
      startIcon={<i className='material-icons'>download</i>}
      onClick={onDownloadCondiciones}
    >
      Descargar condiciones de contratación
    </Button>
    <Button
      color="primary"
      variant='contained'
      startIcon={<i className='material-icons'>download</i>}
      onClick={onDownloadRGPD}
    >
      Descargar aceptación RGPD
    </Button>
  </div>
)

export default DescargarDocumentos